import { getLocale } from '@/helpers/locale-helper';

export function formatErrorToHtml(error, header = '') {
  let messageText = '';
  if (header) {
    messageText += `<b>${getLocale(header)}</b></br>`;
  }
  if (error) {
    if (error.errorId) {
      messageText += getLocale('common.errorCode') + error.errorId + '</br>';
      if (error.parsedMessage) {
        messageText += getLocale('common.errorMessage') + error.parsedMessage + '</br>';
      } else {
        let messages = error.message.split('ORA-20101:');
        let message = error.message;
        if (messages && messages.length > 1) {
          messages = messages[1].split('ORA');
          if (messages && messages.length) {
            message = messages[0];
          }
        }
        messageText += getLocale('common.errorMessage') + message + '</br>';
      }
    } else if (error.code) {
      messageText += getLocale('common.errorCode') + error.code + '</br>';
      messageText += getLocale('common.errorMessage') + (error.parsedMessage || error.message) + '</br>';
    } else if (error.parsedMessage) {
      messageText += error.parsedMessage;
    } else if (error.message) {
      messageText += error.message;
    } else {
      messageText += JSON.stringify(error);
    }
  }

  return messageText;
}

export function parseOracleErrMsg(msg: string): string {
  let ret = '';
  if (msg && /ora-/i.test(msg)) {
    let arr = (msg.split(/\s*\t*\n*ora-\d*:\s*\t*\n*/i) || []).filter(el => !!el);
    if (arr.length) {
      ret = arr[0];
    }
  }
  return ret;
}

export function parsePostgresErrMsg(msg: string): string {
  let ret = '';
  if (msg && /2010\d:/ig.test(msg)) {
    let arr = (msg.split(/\s*\t*\n*2010\d:\s*\t*\n*/i) || []).filter(el => !!el);
    if (arr.length) {
      ret = arr[0];
    }
  }
  return ret;
}
